import { render, staticRenderFns } from "./CardDetail.vue?vue&type=template&id=0f5e8804&"
import script from "./CardDetail.vue?vue&type=script&lang=js&"
export * from "./CardDetail.vue?vue&type=script&lang=js&"
import style0 from "./CardDetail.vue?vue&type=style&index=0&id=0f5e8804&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports